<template>
  <Asset
    name="logo.svg"
    alt="Logo Parcelex"
    title="Logo Parcelex"
    class="checkout-header-logo"
    v-apply-theme
  />
</template>

<script>
import Asset from '@/components/common/Asset.vue';
import { ApplyTheme } from '@/directives/applyTheme';

export default {
  name: 'checkout-header',
  components: {
    Asset,
  },
  directives: {
    ApplyTheme,
  },
};
</script>

<style lang="scss" scoped>
.checkout-header-logo {
  width: 120px;
  height: 25.6px;
  margin-bottom: 15px;
  &--vivo {
    width: 252px;
    height: 54px;
  }
}
</style>
